/** One shared requestAnimationFrame loop for every animation on the page. */
export type FrameCallback = (now: number, dt: number) => void;

const callbacks = new Set<FrameCallback>();
let handle = 0;
let last = 0;

function loop(now: number) {
  const dt = last ? (now - last) / 1000 : 0;
  last = now;
  for (const cb of callbacks) cb(now, dt);
  if (callbacks.size) handle = requestAnimationFrame(loop);
  else {
    handle = 0;
    last = 0;
  }
}

export function onFrame(cb: FrameCallback): () => void {
  callbacks.add(cb);
  if (!handle) handle = requestAnimationFrame(loop);
  return () => {
    callbacks.delete(cb);
  };
}

export function prefersReducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
